import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { EarnPointsModel } from './models/earn-points.model';

export interface EarnPointsState extends EntityState<EarnPointsModel> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'earn-points', idKey: 'SectionId' })
export class EarnPointsStore extends EntityStore<EarnPointsState> {
  constructor() {
    super();
  }
}
